export function httpErrorHandler(error) {
    if (error.config.skipErrorHandling) return Promise.reject(error);

    if (!error.response) {
        this.$message.error(this.$ml.get("apiErrorNoConnect"));
    } else if (error.response.status === 401) {
        this.$auth.lock().then(() => {
            this.$router.push({
                path: "/login",
                query: {
                    redirect: this.$router.currentRoute.fullPath
                }
            });
        });
    } else if (error.response.status === 403) {
        if (this.$router.currentRoute.path !== "/login") {
            this.$message.error(this.$ml.get("apiError403"));
        }
    } else if (error.response.status === 404) {
        this.$message.error(this.$ml.get("apiError404"));
    } else if (error.response.status === 500) {
        this.$message.error(this.$ml.get("apiError500"));
    } else {
        return Promise.reject(error);
    }
}
